import React, { useState, useEffect, useContext } from "react";
import {
	Container,
	makeStyles,
	TableBody,
	TableHead,
	TablePagination,
	Grid,
	useMediaQuery,
	useTheme,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Button,
	Dialog,
	DialogActions,
	DialogTitle,
	Slide,
} from "@material-ui/core";
//import { useForm } from "react-hook-form";
import { AuthContext } from "../context";
import { laboratoryServices, operatorServices } from "../services";
import { Toast, SimpleToolbar, Loader, PatientAssign, Drawer, StyledTableCell, StyledTableRow, BaseTable } from "../components";
import { useDrawer } from "../hooks";

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function AssignedOperators(props) {
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
	const classes = useStyles();
	const [assignments, setAssignments] = useState([]);
	const { authState, signOut } = useContext(AuthContext);
	const [loading, setLoading] = useState(false);
	const [limit, setLimit] = useState(100);
	const [page, setPage] = useState(1);
	const [count, setCount] = useState(0);
	const [toast, setToast] = useState(false);
	const [toastMessage, setToastMessage] = useState("");
	const [reload, setReload] = useState(false);
	const [openAlert, setOpenAlert] = useState(false);
	const [assignmentId, setAssignmentId] = useState(null);
	const [operatorId, setOperatorId] = useState(null);
	const [operators, setOperators] = useState([]);
	const { isOpen, setIsOpen } = useDrawer();

	useEffect(() => {
		setReload(false);
		async function getAssignments() {
			try {
				setLoading(true);
				const { status, response } = await laboratoryServices.getAssignedOperators({
					laboratoryId: authState.user.laboratory._id,
					page,
					limit,
					token: authState.token,
					text: "",
				});
				setLoading(false);
				if (status === 200) {
					setAssignments(response.assigments);
					setLimit(response.limit);
					setCount(response.total);
					setPage(response.page);
				} else if (status === 401) {
					signOut();
				}
			} catch (e) {
				setLoading(false);
				console.log(e);
			}
		}
		getAssignments();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [page, limit, authState, reload, signOut]);

	useEffect(() => {
		async function getOperators() {
			try {
				setLoading(true);
				const { status, response } = await operatorServices.getOperators({ token: authState.token, page, limit });
				setLoading(false);
				if (status === 200) {
					setOperators(response.operators);
					setLimit(response.limit);
					setCount(response.total);
					setPage(response.page);
				} else if (status === 401) {
					signOut();
				}
			} catch (e) {
				setLoading(false);
				console.log(e);
			}
		}
		getOperators();
	}, [page, limit, authState, signOut]);

	const confirmationModal = ({ assignment }) => {
		setOperatorId(assignment.operator._id);
		setAssignmentId(assignment._id);
		setOpenAlert(true);
	};

	const getAssignmentsFilter = async (text) => {
		try {
			setLoading(true);
			const { status, response } = await laboratoryServices.getAssignedOperators({
				laboratoryId: authState.user.laboratory._id,
				page,
				limit,
				token: authState.token,
				text,
			});
			setLoading(false);
			if (status === 200) {
				setAssignments(response.assigments);
				setLimit(response.limit);
				setCount(response.total);
				setPage(response.page);
			} else if (status === 401) {
				signOut();
			}
		} catch (e) {
			setLoading(false);
			console.log(e);
		}
	};

	const assignOperator = async () => {
		setOpenAlert(false);
		try {
			setLoading(true);
			const { status, response } = await laboratoryServices.putOperatorToAssign({ _id: assignmentId, operatorId });
			setLoading(false);
			if (status === 200) {
				setToast(true);
				setToastMessage(response.message);
				setReload(true);
			} else if (status === 401) {
				signOut();
			} else {
				if (response.error) {
					setToast(true);
					setToastMessage(response.error.message);
				}
			}
		} catch (e) {
			console.log(e);
			setLoading(false);
		}
	};

	return (
		<>
			<Drawer open={isOpen} setOpen={(value) => setIsOpen(value)} />
			<Grid container className={classes.container} style={{ flex: 1 }}>
				<Dialog maxWidth="sm" fullScreen={fullScreen} open={openAlert} TransitionComponent={Transition}>
					<>
						<DialogTitle id="alert-dialog-slide-title">Seleccione al operador</DialogTitle>
						<DialogActions style={{ justifyContent: "center" }}>
							<Grid container spacing={2}>
								<Grid item lg={12} xs={12} sm={12}>
									<FormControl variant="outlined" className={`${classes.formControl}  ${classes.shrinkLabel}`}>
										<InputLabel id="demo-simple-select-outlined-label">Operadores</InputLabel>
										<Select
											labelId="demo-mutiple-name-label"
											id="demo-mutiple-name"
											label="Especialidades"
											value={operatorId}
											onChange={(e) => setOperatorId(e.target.value)}
										>
											{operators.map((operator) => (
												<MenuItem key={operator._id} value={operator._id}>
													{operator.name} {operator.lastName}
												</MenuItem>
											))}
										</Select>
									</FormControl>
								</Grid>
								<Grid item lg={6} xs={12} sm={6}>
									<Button fullWidth className={classes.btnCancel} onClick={() => setOpenAlert(false)} variant="text">
										Cancelar
									</Button>
								</Grid>
								<Grid item lg={6} xs={12} sm={6}>
									<Button fullWidth className={classes.btnConfirm} onClick={assignOperator} variant="text">
										Aceptar
									</Button>
								</Grid>
							</Grid>
						</DialogActions>
					</>
				</Dialog>
				{loading && <Loader loading={true} />}
				<Grid item sm={12} xs={12}>
					<div className={classes.root}>
						<Toast
							message={toastMessage}
							open={toast}
							close={() => {
								setToast(false);
							}}
						/>
						<Container maxWidth={false}>
							<SimpleToolbar
								reload={() => setReload(true)}
								onFilter={(text) => getAssignmentsFilter(text)}
								table={"assignedOperators"}
								filename={"Opeadores asignados"}
								isOpen={isOpen}
								setIsOpen={(value) => setIsOpen(value)}
							/>
							<BaseTable tableId="assignedOperators">
								<TableHead>
									<StyledTableRow>
										<StyledTableCell>Productos</StyledTableCell>
										<StyledTableCell>Operador asignado</StyledTableCell>
										<StyledTableCell>Rut operador</StyledTableCell>
										<StyledTableCell>Paciente</StyledTableCell>
										<StyledTableCell>Rut paciente</StyledTableCell>
										<StyledTableCell>Opciones</StyledTableCell>
									</StyledTableRow>
								</TableHead>
								<TableBody>
									{assignments.map((assignment, index) => (
										<PatientAssign
											index={index}
											operator={assignment.operator}
											assignment={assignment}
											onClickAssign={() => confirmationModal({ assignment })}
										/>
									))}
								</TableBody>
							</BaseTable>
							<TablePagination
								labelRowsPerPage="Registros por página"
								component="div"
								count={count}
								onChangeRowsPerPage={(e) => {
									setLimit(e.target.value);
								}}
								onChangePage={(e, page) => {
									setPage(page + 1);
								}}
								page={page - 1}
								rowsPerPage={limit}
								rowsPerPageOptions={[10, 25, 50, 100]}
								classes={{ root: classes.pagination }}
							/>
						</Container>
					</div>
				</Grid>
			</Grid>
		</>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		paddingBottom: theme.spacing(2),
		paddingTop: theme.spacing(2),
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	form: {
		marginTop: theme.spacing(2),
	},
	submit: {
		margin: theme.spacing(3, 0, 2),
	},
	textField: {
		width: "100%",
	},
	btnCancel: {
		backgroundColor: theme.palette.secondary.main,
		color: "#FFF",
		"&:hover": {
			backgroundColor: theme.palette.secondary.main,
		},
	},
	btnConfirm: {
		backgroundColor: theme.palette.primary.main,
		color: "#FFF",
		"&:hover": {
			backgroundColor: theme.palette.primary.main,
		},
	},
	closeButton: {
		position: "absolute",
		right: theme.spacing(1),
		top: theme.spacing(1),
		color: "#f44336",
	},
	dialogTitle: {
		textAlign: "Center",
	},
	shrinkLabel: {
		"& > label:nth-child(1)": {
			transform: "translate(14px, -6px) scale(0.75)",
		},
		"& > div:nth-child(2)": {
			"& > fieldset": {
				"& > legend": {
					maxWidth: 1000,
				},
			},
		},
	},
	formControl: {
		width: "100%",
		minWidth: 120,
	},
}));
